<script>
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
      'Graduation': 'Graduação',
    },
    es: {
      'Graduation': 'Graduación',
    }
  },
  data() {
    return {
      graduations: [], // lista de graduações (NÃO inclui o nível base "Sem Graduação")
      points: 0, // pontos da equipe menor (mesmo valor usado em reports/graduation.vue)
      previous: {
        id: null,
        name: '',
        points: 0,
        image: null,
      },
      next: {
        id: null,
        name: '',
        points: 0,
        image: null
      },
    };
  },
  computed: {
    pins() {
      const usedPoints = parseFloat(this.points) || 0;
      let lowerBound = 0;

      return this.graduations.map(g => {
        const upperBound = parseFloat(g.points) || 0;

        let percent = 0;
        if (upperBound > lowerBound) {
          percent = ((usedPoints - lowerBound) / (upperBound - lowerBound)) * 100;
        } else {
          percent = usedPoints >= upperBound ? 100 : 0;
        }
        percent = Math.min(100, Math.max(0, percent));

        lowerBound = upperBound;

        return {
          ...g,
          percent
        };
      });
    },
    activePinId() {
      if (this.next && this.next.id) return this.next.id;
      return this.graduations.length ? this.graduations[this.graduations.length - 1].id : null;
    }
  },
  methods: {
    getGraduation() {
      api
        .get('reports/graduation')
        .then(response => {
          if (response.data.status == 'success') {
            this.graduations = response.data.list;
            this.points = response.data.graduation.points;
            this.previous = response.data.graduation.previous;
            this.next = response.data.graduation.next;

            this.$nextTick(this.scrollToCurrent);
          }
        });
    },
    scrollToCurrent() {
      const container = this.$refs.pins;
      const current = Array.isArray(this.$refs.currentPin) ? this.$refs.currentPin[0] : this.$refs.currentPin;
      if (!container || !current) return;

      container.scrollLeft = current.offsetLeft - (container.clientWidth / 2) + (current.clientWidth / 2);
    }
  },
  created() {
    this.getGraduation();
  }
};
</script>

<template>
  <fieldset class="pb-2">
    <legend>{{ t('Graduation') }} <sup class="font-weight-light">{{ this.$moment().format('MM/YYYY') }}</sup></legend>
    <div class="w-100">
      <div ref="pins" class="d-flex graduation-pins">
        <div v-for="g in pins" :key="g.id" :ref="g.id === activePinId ? 'currentPin' : null" class="text-center graduation-pin flex-shrink-0">
          <div v-if="g.image" class="pin-watermark" :style="{ backgroundImage: 'url(' + require('@/assets/images/graduations/' + g.image) + ')' }"></div>

          <div class="pin-content">
            <span class="badge badge-soft-dark points-badge font-size-14 font-weight-bold notranslate" :style="g.percent >= 100 ? { background: '#3b2fe8', color: '#F2BD5E' } : null">
              {{ g.points | points }}
              <svg v-if="g.percent >= 100" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="points-badge-icon" style="fill: #F2BD5E;">
                <path d="M17 2h-4v4.059a8.946 8.946 0 0 1 4 1.459V2zm-6 0H7v5.518a8.946 8.946 0 0 1 4-1.459V2zm1 20a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm-1.225-8.519L12 11l1.225 2.481 2.738.397-1.981 1.932.468 2.727L12 17.25l-2.449 1.287.468-2.727-1.981-1.932 2.737-.397z"></path>
              </svg>
            </span>
            <div class="graduation-icon">
              <img v-if="g.image" :src="require('@/assets/images/graduations/' + g.image)" class="icon-base" />
              <img v-else src="@/assets/images/logo-icon.png" class="icon-base" />
              <div class="icon-fill" :style="{ width: g.percent + '%' }">
                <img v-if="g.image" :src="require('@/assets/images/graduations/' + g.image)" />
                <img v-else src="@/assets/images/logo-icon.png" />
              </div>
            </div>
            <div class="font-size-12 font-weight-bold text-uppercase mt-1 notranslate graduation-name">{{ g.name }}</div>
            <b-progress style="border-radius: 3px;" :value="g.percent" variant="default" height="15px" class="rounded-lg mt-2"></b-progress>
            <div class="font-size-12">{{ g.percent.toFixed(0) }}%</div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<style scoped>
.graduation-pins {
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 5px;
  scroll-behavior: smooth;
}

@media (min-width: 992px) {
  .graduation-pins {
    justify-content: space-between;
  }
}

.graduation-pin {
  position: relative;
  width: 100px;
}

.pin-watermark {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 220%;
  opacity: 0.1;
  z-index: 0;
  pointer-events: none;
  box-shadow: inset 15px 15px 15px 0px rgba(255, 255, 255, 1), inset -15px -30px 15px 0px rgba(255, 255, 255, 1);
}

.pin-content {
  position: relative;
  z-index: 10;
}

.graduation-name {
  /* reserva altura de 2 linhas e centraliza nomes de 1 linha */
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 2.4em;
  line-height: 1.2;
  text-align: center;
  white-space: normal;
  word-break: break-word;
}

.points-badge {
  position: relative;
  display: block;
  padding: 5px;
  margin-bottom: 15px;
  white-space: nowrap;
  overflow: visible;
  z-index: 3;
}

.points-badge-icon {
  position: absolute;
  top: -2px;
  right: -4px;
  width: 32px;
  height: 32px;
  z-index: 11;
}

.graduation-icon {
  position: relative;
  width: 80px;
  height: 80px;
  margin: 0 auto;
}

.graduation-icon img {
  background: #CED4DB;
  border-radius: 100%;
  width: 80px;
  height: 80px;
  display: block;
}

.icon-base {
  opacity: 0.35;
}

.icon-fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 80px;
  overflow: hidden;
}

.progress {
  background-color: #fff;
  border: solid 1px #031C3D;
}
</style>
